var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FdTable',{attrs:{"striped":"","headers":_vm.headers,"items":_vm.items},scopedSlots:_vm._u([{key:"row",fn:function(ref){
var item = ref.item;
return [_c('FdTableRow',[_c('FdTableCell',[_vm._v(_vm._s(item.firstName))]),_c('FdTableCell',[_vm._v(_vm._s(item.lastName))]),_c('FdTableCell',[_vm._v(_vm._s(item.building))])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }